import React from 'react'
import utils from './utils'

function getLevelLayout(width, height, settings, quantities, answer) {
    return getLayout(width, height, settings, quantities, answer)
}

function getLayout(width, height, settings, quantities, answer) {
    const {
        gameContainerWidth,
        gameContainerHeight,
        lineWeight,
    } = getLayoutSettings(width, height)
    const operationSymbol = settings.operation === 'addition' ? '+' : '-'
    const fontSize = gameContainerWidth / 15
    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}
        >
            {getDotsLayout(quantities, gameContainerWidth, gameContainerHeight, lineWeight, settings)}
        </svg>
    )
}

function getDotsLayout(quantities, width, height, lineWeight, settings) {
    const fontSize = width / 15
    const operationSymbol = settings.operation === 'addition' ? '+' : '-'
    const isVertical = settings.position === 'vertical' ? true : false

    let value1 = quantities.value_1
    let gridWidht1 = settings.show_grid ? (settings['value_1_width'] || value1) : value1
    let gridHeight1 = settings.show_grid ? (settings['value_1_height'] || 1) : 1
    let colour1 = settings['value_1_colour'] || 'silver'

    let value2 = quantities.value_2
    let gridWidht2 = settings.show_grid ? (settings['value_2_width'] || value2) : value2
    let gridHeight2 = settings.show_grid ? (settings['value_2_height'] || 1) : 1
    let colour2 = settings['value_2_colour'] || 'silver'

    let maxSize = gridWidht1 > gridWidht2 ? width / gridWidht1 :  width / gridWidht2
    let sideOffset1 = 0
    let sideOffset2 = 0
    let topOffset1 = 0
    let topOffset2 = 0

    let size1 = 0
    let dots1 = []
    let gridLayout1 = null

    let size2 = 0
    let dots2 = []
    let gridLayout2 = null

    let dotsHeight1 = 0
    let dotsHeight2 = 0

    let dotsWidht1 = 0
    let dotsWidht2 = 0

    let symbolPosX = 0
    let symbolPosY = 0


    if (isVertical) {
        const gridMaxHeight = (height / 2 - fontSize / 2)

        if (width / gridWidht1 > gridMaxHeight / gridHeight1) {
            size1 = gridMaxHeight / gridHeight1
            size1 = size1 > maxSize ? maxSize : size1
        } else {
            size1 = width / gridWidht1 - (settings.show_grid ? lineWeight : 0)
            size1 = size1 > maxSize ? maxSize : size1
        }

        if (width / gridWidht2 > gridMaxHeight / gridHeight2) {
            size2 = gridMaxHeight / gridHeight2
            size2 = size2 > maxSize ? maxSize : size2
        } else {
            size2 = width / gridWidht2 - (settings.show_grid ? lineWeight : 0)
            size2 = size2 > maxSize ? maxSize : size2
        }


        dotsHeight1 = size1 * gridHeight1
        dotsHeight2 = size2 * gridHeight2

        dotsWidht1 = size1 * gridWidht1
        dotsWidht2 = size2 * gridWidht2

        sideOffset1 = (width - size1 * gridWidht1) / 2
        sideOffset2 = (width - size2 * gridWidht2) / 2
        topOffset1 = (height - dotsHeight1 - dotsHeight2 - fontSize) / 2
        topOffset2 = topOffset1 + dotsHeight1 + fontSize
        symbolPosX = width / 2
        symbolPosY = topOffset1 + dotsHeight1 + fontSize / 2

    } else {
        const gridWidht = +gridWidht1 + +gridWidht2 + 1
        const gridHeight = +gridHeight1 > +gridHeight2 ? +gridHeight1 : +gridHeight2
        if (width / gridWidht > height / gridHeight) {
            size1 = size2 = height / gridHeight
            size1 = size2 = size1 > maxSize ? maxSize : size1
        } else {
            size1 = size2 = width / gridWidht - (settings.show_grid ? lineWeight : 0)
            size1 = size2 = size1 > maxSize ? maxSize : size1
        }

        dotsHeight1 = size1 * gridHeight1
        dotsHeight2 = size2 * gridHeight2

        dotsWidht1 = size1 * gridWidht1
        dotsWidht2 = size2 * gridWidht2

        sideOffset1 = (width - dotsWidht1 - dotsWidht2 - fontSize) / 2
        sideOffset2 = sideOffset1 + dotsWidht1 + fontSize
        topOffset1 = (height - size1 * gridHeight1) / 2
        topOffset2 = (height - size2 * gridHeight2) / 2
        symbolPosX = sideOffset1 + dotsWidht1 + fontSize / 2
        symbolPosY = height / 2
    }

    let circleSize1 = size1 / 1.3
    let circleSize2 = size2 / 1.3

    if (settings.show_grid) {
        let gridPath1 = ''
        let gridPath2 = ''

        for (let i = 1; i < gridHeight1; i++) {
            gridPath1 += `M ${sideOffset1} ${topOffset1 + size1 * i} H ${sideOffset1 + size1 * gridWidht1}`
        }

        for (let i = 1; i < gridWidht1; i++) {
            gridPath1 += `M ${sideOffset1 + size1 * i} ${topOffset1} V ${topOffset1 + size1 * gridHeight1}`
        }

        for (let i = 1; i < gridHeight2; i++) {
            gridPath2 += `M ${sideOffset2} ${topOffset2 + size2 * i} H ${sideOffset2 + size2 * gridWidht2}`
        }

        for (let i = 1; i < gridWidht2; i++) {
            gridPath2 += `M ${sideOffset2 + size2 * i} ${topOffset2} V ${topOffset2 + size2 * gridHeight2}`
        }

        gridLayout1 = (
            <g>
                <rect
                    x={sideOffset1}
                    y={topOffset1}
                    width={size1 * gridWidht1}
                    height={size1 * gridHeight1}
                    fill='none'
                    strokeWidth={lineWeight}
                    stroke="white"
                />
                <path
                    d={gridPath1}
                    fill="none"
                    stroke="white"
                    strokeWidth={lineWeight}
                />
            </g>
        )

        gridLayout2 = (
            <g>
                <rect
                    x={sideOffset2}
                    y={topOffset2}
                    width={size2 * gridWidht2}
                    height={size2 * gridHeight2}
                    fill='none'
                    strokeWidth={lineWeight}
                    stroke="white"
                />
                <path
                    d={gridPath2}
                    fill="none"
                    stroke="white"
                    strokeWidth={lineWeight}
                />
            </g>
        )
    }

    for (let i = 1; i <= gridHeight1; i++) {
        for (let j = 1; j <= gridWidht1; j++) {
            if (value1 >= (j + (i - 1) * gridWidht1)) {
                dots1.push(
                    utils.getGear(sideOffset1 + size1 * j - size1 / 2, topOffset1 + size1 * i - size1 / 2, circleSize1, colour1)
                )
            }
        }

    }

    for (let i = 1; i <= gridHeight2; i++) {
        for (let j = 1; j <= gridWidht2; j++) {
            if (value2 >= (j + (i - 1) * gridWidht2)) {
                dots2.push(
                    utils.getGear(sideOffset2 + size2 * j - size2 / 2, topOffset2 + size2 * i - size2 / 2, circleSize2, colour2)
                )
            }
        }

    }


    return (
        <g>
            {gridLayout1}
            {dots1}

            {utils.getOperationSign(
                symbolPosX,
                symbolPosY,
                fontSize / 1.2,
                settings.operation === 'addition' ? 'plus' : 'minus'
            )}

            {gridLayout2}
            {dots2}
        </g>
    )

}

function getLayoutSettings(gameContainerWidth, gameContainerHeight) {

    /* const gameContainerMargin = gameContainerWidth * .04
 
    if (gameContainerWidth * 0.6 > gameContainerHeight) {
        gameContainerWidth = gameContainerHeight / 0.6 - gameContainerMargin
        gameContainerHeight = gameContainerHeight - gameContainerMargin
    } else {
        gameContainerWidth = gameContainerWidth - gameContainerMargin
        gameContainerHeight = gameContainerWidth * 0.6 - gameContainerMargin
    } */

    const sideMargin = gameContainerWidth * .15
    const marginBottom = gameContainerWidth * .1
    const lineWeight = gameContainerWidth / 300
    const arrowSize = gameContainerWidth / 35
    const fontSize = gameContainerWidth / 15

    const gridCount = 5
    const rectWidth = gameContainerWidth - lineWeight * 2 - sideMargin * 2
    const rectHeight = rectWidth / gridCount * 2

    return {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        rectWidth,
        rectHeight,
        marginBottom,
        lineWeight,
        arrowSize,
        fontSize,
        gridCount
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/dotsPair.utils.js